import { render, staticRenderFns } from "./news.vue?vue&type=template&id=1ff72aec&scoped=true&"
import script from "./news.vue?vue&type=script&lang=ts&"
export * from "./news.vue?vue&type=script&lang=ts&"
import style0 from "./news.vue?vue&type=style&index=0&id=1ff72aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff72aec",
  null
  
)

export default component.exports